import {IObjectType, IRule, IRuleset, TDataSourceType} from "../../index";
import {ObjectTypeId} from "../../constants";
import {IObjectDefinition} from "../../util/misc";
import {IDialogOpt} from "../dialog/manager";
import {MutableRule} from "./mutable/rule/MutableRule";
import {MutableRuleset as MutableRuleset} from "./mutable/mutableRuleset";
import {AvailableData} from "./mutable/rule/AvailableData";

interface IRuleMutableAttribute {
    attribute: KnockoutObservable<IRule['attribute'] | null>
}

interface IRulesetMutable {
    $original: IRuleset
    authdatasources: KnockoutObservable<TDataSourceType>
    companyid: KnockoutObservable<string>
    departmentexpression: KnockoutObservable<IRuleset['departmentexpression']>
    description: KnockoutObservable<string>
    evaluatepositions: KnockoutObservable<IRuleset['evaluatepositions']>
    name: KnockoutObservable<string>
    objectType: KnockoutObservable<IFullObjectType | null>
    rules: KnockoutObservableArray<MutableRule>
}

interface IFullObjectType {
    def: IObjectDefinition
    id: ObjectTypeId
    type: IObjectType
}

interface IWizardParams {
    __dialog: IDialogOpt
    availableData: AvailableData
    mutableRuleset: MutableRuleset
    objectType: KnockoutObservable<IObjectType>
}

interface IUpdateRulesetEventParams {
    eventId: string
    oldRuleset: IRuleset
    newRuleset: IRuleset
}

interface ICreateRulesetEventParams {
    eventId: string
    newRuleset: IRuleset
}